import { FC } from 'react';
import { TPointSummary } from '../../../mapTypes';

interface IPolygonPopupContentProps {
	info: TPointSummary;
}

const PolygonPopupContent: FC<IPolygonPopupContentProps> = ({ info }) => (
	<>
		{info?.id && (
			<div>
				<span className="font-bold">Polygon ID: </span>
				<span>{info.id}</span>
			</div>
		)}
		{info?.portName && (
			<div>
				<span className="font-bold">Name: </span>
				<span>{info.portName}</span>
			</div>
		)}
		{info?.polygonType && (
			<div>
				<span className="font-bold">Polygon Type: </span>
				<span>{info.polygonType}</span>
			</div>
		)}
		{info?.region && (
			<div>
				<span className="font-bold">Region: </span>
				<span>{info.region}</span>
			</div>
		)}
		{info?.country && (
			<div>
				<span className="font-bold">Country: </span>
				<span>{info.country}</span>
			</div>
		)}
	</>
);

export default PolygonPopupContent;
